(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('LanguageLocalizationDetailController', LanguageLocalizationDetailController);

    LanguageLocalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'LanguageLocalization'];

    function LanguageLocalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, LanguageLocalization) {
        var vm = this;

        vm.languageLocalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:languageLocalizationUpdate', function(event, result) {
            vm.languageLocalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
